module.exports = __webpack_public_path__ + "img/insurance_info.ef9861fc.jpg";